import { createSlice } from '@reduxjs/toolkit';
import {Address} from '../enums/checkoutShipping';
import { LoginUserEditFormState } from '../enums/checkoutShipping';
import AddressModel from "../models/address";
import { config } from '../utils/config';
import reducers from "./shippingReducers"

const initialShippingState = {
    address : {
        shippingAddress : new AddressModel(),
        billingAddress: new AddressModel(),
        showShippingError: false,
        shippingError: '',
        cartVersion : '',
        customerVersion : '',
        shippingBillingAgreement : '',
        currentSelectedCountry : config('regionCode'),
        isValidEmail: '',
        isPostalCodeBlur: true,
        validatedEmail: '',
        oldVatId: '',
        oldVatCountry: '',
        vatStatus: '',
        oldVat : null,
        oldUsbVat : null,
        vatUpdateMsg : '',
        shipAddressModified : true,
        billAddressModified : true,
        isManualShippingAddress: false,
        isManualBillingAddress:false,
        defaultShippingAddress: false,
        defaultBillingAddress:false,
        taxActions : [],
        moveToPaymentPage : false,
        cartAddressAdded : false,
        backToPreviousPage : false,
    },
    loqate : {
        loqateEnabled : false,
        suggestedShippingAddress : {},
        suggestedBillingAddress : {},
        shippingAddressType: 'UNKNOWN',
        billingAddressType: 'UNKNOWN',
        isLoqateSuggestedAddress: false,
        formattedShippingAddress: {},
        formattedBillingAddress: {},
        showShippingPopup : false,
        showBillingPopup : false,
        blockShippingLoqateAutocomplete : false,
        blockBillingLoqateAutocomplete : false,
        shippingAQI : '',
        billingAQI : ''
    },
    error: {
        isError: false,
        errorObj: {
            message: "",
            operation: "",
        }
    },
    loginUserEditForm : {
        state: LoginUserEditFormState.CLOSE,
        editAddressId : '',
        editAddressType: Address.SHIPPING,
        editedByUser : true,
        shippingAddressId : '',
        billingAddressId: ''
    },
    contactPreference : { 
        emailAddress: '',
        subscribe: 'N/A',
        displayError: 'false',
        isEmailChanged: false,
        displayContactPreference: false
    }
};

const shippingSlice = createSlice({
    name: 'shippingState',
    initialState: initialShippingState,
    reducers: reducers
});

export default shippingSlice;
